<script setup>
import PlayerAvatar from './PlayerAvatar.vue';
import PlayerIdentity from './PlayerIdentity.vue';
import ClubLogo from './ClubLogo.vue';
import { computed } from 'vue';
import { useFootballClubs } from '../composables/useFootballClubs.js';
import { playerClub } from '../domain/footballClub.js';

const props = defineProps({
  player: { type: Object, required: true },
});
defineEmits(['open']);

/* Verein aus dem Klubregister (Verweis), sonst der alte Text */
const { byId } = useFootballClubs();
const club = computed(() => playerClub(byId.value, props.player));

/* Leerer touchstart-Handler: Ohne ihn wendet iOS Safari :active auf Zeilen nicht
   zuverlässig an (Klick-Rückmeldung in main.css). */
const noop = () => {};

/* Der aufnehmende Verein steht hier nur als Text mit Logo. Geändert wird er
   ausschließlich in Player Info (SectorPass.vue) — ein Textfeld in der Liste
   fing früher Enter und "Weiter" der Suche ab. */
</script>

<template>
  <!-- Die ganze Zeile öffnet das Profil (früher nur Foto/Name und Verein, der Rand
       dazwischen war tot), tastaturbedienbar wie in PlayerRow.vue. -->
  <div
    class="row"
    role="button"
    tabindex="0"
    @keydown.enter.self.prevent="$emit('open', player.id)"
    @keydown.space.self.prevent="$emit('open', player.id)"
    @touchstart.passive="noop"
    @click="$emit('open', player.id)"
  >
    <div class="row-click">
      <PlayerAvatar :player="player" :size="40" />
      <span class="body">
        <PlayerIdentity :player="player" :show-status="false" />
      </span>
    </div>

    <div v-if="club.name || club.logoPath" class="current-club">
      <svg class="cc-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" />
      </svg>
      <ClubLogo :path="club.logoPath" :size="28" />
      <span v-if="club.name" class="cc-name">{{ club.name }}</span>
    </div>
  </div>
</template>
